// extracted by mini-css-extract-plugin
export default {"container":"content_container__6C9E1"};